export default Object.freeze({
  DENTIST_SURGEON: 'Chirurgien dentiste',
  ORTHODONTIST: 'Orthodontiste',
  DENTURES_LAB: 'Laboratoire de prothèses',
});
